import {
  db,
  Admintables,
  BHUtables,
  RHCtables,
  XpertSitetables,
  Ridertables,
  DistrictFieldSupervisortables,
} from '../../db'
import * as Common from '../CommonControlls/CommonJs'
import $ from 'jquery'

export const SyncConfig = (Success_callback, Error_Callback) => {
  Common.parseJwt(getAuthToken(), (user) => {
    db.LoggedInUser.toArray()
      .then((FoundUser) => {
        if (
          FoundUser.length === 0 ||
          user.id !== FoundUser[0].id ||
          user.roleId !== FoundUser[0].roleId
        ) {
          db.District.clear()
          db.HCF.clear()
          db.Patients.clear()
          db.PatientSamples.clear()
          db.Roles.clear()
          db.Riders.clear()
          db.XpertSite.clear()
          db.LoggedInUser.clear()
          db.ActivityLog.where('UserId').equals(user.id).delete()
        }
        db.LoggedInUser.put({ id: user.id, roleId: user.roleId })
          .then((re) => {
            var DBtables =
              user.roleId === 1 || user.roleId === 8
                ? Admintables
                : user.roleId === 6
                ? BHUtables
                : user.roleId === 7
                ? RHCtables
                : user.roleId === 3
                ? XpertSitetables
                : user.roleId == 4
                ? Ridertables
                : user.roleId == 5
                ? DistrictFieldSupervisortables
                : []
            SyncDataOffline(
              user.id,
              user.roleId,
              (table, count, type) => {
                if (DBtables.length > 0 && type === 1) {
                  if (DBtables.length === count) {
                    Common.Ajax(
                      getAuthToken(),
                      'Get',
                      false,
                      Common.APILinks.GetMaxEventId,
                      {},
                      (response) => {
                        if (response.status === true) {
                          db.ActivityLog.get({ UserId: user.id }).then(
                            (res) => {
                              if (res === undefined) {
                                var obj = {
                                  Id: response.maxId,
                                  UserId: user.id,
                                }
                                db.ActivityLog.put(obj)
                              } else {
                                var obj = {
                                  Id: response.maxId,
                                  UserId: user.id,
                                  LocalId: res[0]?.LocalId,
                                }
                                db.ActivityLog.put(obj)
                              }
                            },
                          )
                          Success_callback()
                        } else {
                          Error_Callback()
                        }
                      },
                      (error) => {
                        console.log('error in getting max synced events Id')
                        Error_Callback()
                      },
                    )
                  }
                } else {
                  Success_callback()
                }
              },
              () => {
                Error_Callback()
                console.log('error in sync')
              },
            )
          })
          .catch((e) => {
            Error_Callback()
            console.log(e)
          })
      })
      .catch((e) => {
        Error_Callback()
        console.log(e)
      })
  })
}
export const SyncDataOffline = (
  UserId,
  roleId,
  Success_callback,
  Error_Callback,
) => {
  Common.Ajax(
    getAuthToken(),
    'Get',
    false,
    Common.APILinks.CheckServerResponse,
    {},
    (response) => {
      if (response.status === true) {
        var DBtables =
          roleId === 1 || roleId === 8
            ? Admintables
            : roleId == 6
            ? BHUtables
            : roleId === 7
            ? RHCtables
            : roleId === 3
            ? XpertSitetables
            : roleId === 4
            ? Ridertables
            : roleId == 5
            ? DistrictFieldSupervisortables
            : []
        db.ActivityLog.get({ UserId: UserId })
          .then((ActivityResponse) => {
            // get all tables data
            if (ActivityResponse === undefined) {
              if (DBtables.length > 0) {
                let syncedTableCount = 0

                for (var i in DBtables) {
                  Common.Ajax(
                    getAuthToken(),
                    'Get',
                    false,
                    Common.APILinks.GetSyncConfigData,
                    { TableName: DBtables[i] },
                    (response) => {
                      if (response.status === true) {
                        var ConfigDataTemp = $.parseJSON(response.data)
                        $(ConfigDataTemp).each((index, item) => {
                          db.table(response.table).put(item)
                        })
                        syncedTableCount = syncedTableCount + 1
                        Success_callback(response.table, syncedTableCount, 1)
                      } else {
                        console.log('error in complete table sync')
                        Error_Callback()
                      }
                    },
                    (error) => {
                      console.log('error in complete table sync')
                      Error_Callback()
                    },
                  )
                }
              } else {
                Success_callback(null, 0, 1)
              }
            }
            // get pending events
            else {
              Common.Ajax(
                getAuthToken(),
                'Get',
                false,
                Common.APILinks.GetPendingEvents,
                {
                  LastSyncId: ActivityResponse.Id,
                  TableList: convertToString(DBtables),
                },
                (response) => {
                  if (response.status === true && response.data.length > 0) {
                    UpdateSyncedEvents(
                      UserId,
                      response.data,
                      () => {
                        Success_callback('', 0, 2)
                      },
                      () => {
                        Error_Callback()
                      },
                    )
                  } else {
                    Success_callback('', 0, 2)
                  }
                },
                (error) => {
                  Error_Callback()
                  console.log('error in pending events fetch')
                },
              )
            }
          })
          .catch((e) => {
            Error_Callback()
            console.log(e)
          })
      }
    },
    () => {
      Error_Callback()
      console.log('server not connected')
    },
  )
}

function UpdateSyncedEvents(UserId, events, success_callback, error_callback) {
  var EventCount = 0
  var TotalEvents = events.length

  Common.parseJwt(getAuthToken(), (user) => {
    function RenderEventRecord() {
      UpdateEventRecord(
        events[EventCount],
        user,
        (updatedeventId) => {
          db.ActivityLog.get({ UserId: UserId }).then((res) => {
            if (res === undefined) {
              var obj = { Id: updatedeventId, UserId: UserId }
              db.ActivityLog.put(obj)
            } else {
              var obj = {
                Id: updatedeventId,
                UserId: UserId,
                LocalId: res.LocalId,
              }
              db.ActivityLog.put(obj)
            }
            ++EventCount
            if (EventCount < TotalEvents) {
              RenderEventRecord()
            }
            if (EventCount === TotalEvents) {
              success_callback()
            }
          })
        },
        () => {
          error_callback()
        },
      )
    }

    RenderEventRecord()
  })
}

const UpdateEventRecord = (event, user, success_callback, error_callback) => {
  if (event.operation === 'Approve') {
    db.table(event.tableName)
      .get({ id: parseInt(event.data) })
      .then((rec) => {
        rec.isApproved = 1
        db.table(event.tableName)
          .put(rec)
          .then(() => {
            success_callback(event.id)
          })
          .catch((e) => {
            error_callback()
            console.log(e)
          })
      })
      .catch((e) => {
        error_callback()
        console.log(e)
      })
  } else if (
    event.tableName === 'ListSearchHistory' &&
    event.operation === 'Delete'
  ) {
    if (event.data == null) {
      success_callback(event.id)
      return
    }

    db.table(event.tableName)
      .get({ id: parseInt(event.data) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          db.table(event.tableName)
            .where('id')
            .equals(parseInt(event.data))
            .delete()
            .then(() => {
              success_callback(event.id)
            })
            .catch(() => {
              error_callback()
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'Submit'
  ) {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.id) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.patientId = parseInt(EventData.patientId)
          obj.sampleDateTime = EventData.sampleDateTime
          obj.isSubmitted = true
          obj.deliveryStatus = 1
          obj.isNegativeResultBypass = EventData.isNegativeResultBypass
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'Receive'
  ) {
    var EventData = $.parseJSON(event.data)
    EventData.Idlist = EventData.SampleIds.split(',')
    for (var i in EventData.Idlist) {
      EventData.Idlist[i] = parseInt(EventData.Idlist[i])
    }
    db.table(event.tableName)
      .where('id')
      .anyOf(EventData.Idlist)
      .toArray()
      .then((arr) => {
        if (arr.length > 0) {
          var tempArr = arr
          for (var i in tempArr) {
            tempArr[i].receiveDatetime = EventData.receiveDatetime
            tempArr[i].deliveryStatus = EventData.deliveryStatus
          }
          db.table(event.tableName)
            .bulkPut(tempArr)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        } else {
          success_callback(event.id)
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'Collect'
  ) {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.sampleId) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.deliveryStatus = EventData.deliveryStatus
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'Dispatch'
  ) {
    var EventData = $.parseJSON(event.data)
    EventData.Idlist = EventData.SampleIds.split(',')
    for (var i in EventData.Idlist) {
      EventData.Idlist[i] = parseInt(EventData.Idlist[i])
    }
    db.table(event.tableName)
      .where('id')
      .anyOf(EventData.Idlist)
      .toArray()
      .then((arr) => {
        if (arr.length > 0) {
          var tempArr = arr
          for (var i in tempArr) {
            tempArr[i].dispatchDatetime = EventData.dispatchDatetime
            tempArr[i].deliveryStatus = EventData.deliveryStatus
          }
          db.table(event.tableName)
            .bulkPut(tempArr)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        } else {
          success_callback(event.id)
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'SampleResult'
  ) {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.id) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.resultDescription = EventData.resultDescription
          obj.mtbResult = EventData.mtbResult
          obj.rrResult = EventData.rrResult
          obj.deliveryStatus = 5
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'SampleAfbResult'
  ) {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.id) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.afbResult = EventData.afbResult
          obj.afbResultType = EventData.afbResultType
          obj.deliveryStatus = EventData.deliveryStatus
          obj.xpertSiteId = EventData.xpertSiteId
          obj.samplePurpose = EventData.samplePurpose
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'PatientSamples' &&
    event.operation === 'NegativeResultBypass'
  ) {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.sampleId) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.isNegativeResultBypass = EventData.isNegativeResultBypass
          obj.deliveryStatus = EventData.deliveryStatus
          if (EventData.isResetAssignmentId === true) {
            obj.assignmentId = null
          }
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'Assignments' &&
    event.operation === 'Delete'
  ) {
    var EventData = $.parseJSON(event.data)
    var Idlist = EventData.split(',')
    for (var i in Idlist) {
      Idlist[i] = parseInt(Idlist[i])
    }
    db.table('PatientSamples')
      .where('id')
      .anyOf(Idlist)
      .toArray()
      .then((arr) => {
        if (arr.length > 0) {
          var tempArr = arr
          for (var i in tempArr) {
            tempArr[i].deliveryStatus = 1
            tempArr[i].assignmentId = null
          }
          db.table('PatientSamples')
            .bulkPut(tempArr)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        } else {
          success_callback(event.id)
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    (event.tableName !== 'Assignments' && event.operation === 'Delete') ||
    (event.tableName === 'Riders' && event.operation === 'Rejected')
  ) {
    db.table(event.tableName)
      .get({ id: parseInt(event.data) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          db.table(event.tableName)
            .where('id')
            .equals(parseInt(event.data))
            .delete()
            .then(() => {
              success_callback(event.id)
            })
            .catch(() => {
              error_callback()
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (event.tableName === 'Riders' && event.operation === 'Update') {
    var EventData = $.parseJSON(event.data)
    db.table(event.tableName)
      .get({ id: parseInt(EventData.id) })
      .then((obj) => {
        if (obj === undefined) {
          success_callback(event.id)
        } else {
          obj.name = EventData.name
          obj.contact = EventData.contact
          obj.email = EventData.email
          obj.imageURL = EventData.imageURL
          obj.address = EventData.address
          obj.vehicleNumber = EventData.vehicleNumber
          obj.vehicleModel = EventData.vehicleModel
          obj.imageURLBase64 = EventData.imageURLBase64
          obj.accountNumber = EventData.accountNumber
          obj.bankId = EventData.bankId
          db.table(event.tableName)
            .put(obj)
            .then(() => {
              success_callback(event.id)
            })
            .catch((e) => {
              error_callback()
              console.log(e)
            })
        }
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else if (
    event.tableName === 'ListSearchHistory' &&
    event.operation === 'Search'
  ) {
    var EventData = $.parseJSON(event.data)
    if (EventData.userId === parseInt(user.id)) {
      db.table(event.tableName)
        .put(EventData)
        .then(() => {
          success_callback(event.id)
        })
        .catch(() => {
          error_callback()
        })
    } else {
      success_callback(event.id)
    }
  } else {
    var EventData = $.parseJSON(event.data)
    //BHU
    if (
      user.roleId === 6 &&
      (event.tableName === 'Patients' || event.tableName === 'PatientSamples')
    ) {
      if (EventData.hcfId === user.hcfId || EventData.hfcId === user.hcfId) {
        db.table(event.tableName)
          .put(EventData)
          .then(() => {
            success_callback(event.id)
          })
          .catch(() => {
            error_callback()
          })
      } else {
        success_callback(event.id)
      }
    }
    //RHC
    else if (user.roleId === 7 && event.tableName === 'PatientSamples') {
      if (EventData.hfcId === user.hcfId || EventData.rhcId === user.hcfId) {
        db.table(event.tableName)
          .put(EventData)
          .then(() => {
            success_callback(event.id)
          })
          .catch(() => {
            error_callback()
          })
      } else {
        success_callback(event.id)
      }
    }
    //xpert site
    // else if(user.roleId==3 && event.tableName=="PatientSamples")
    // {
    //     if(EventData.xpertSiteId==user.xpertSiteId)
    //     {
    //         db.table(event.tableName).put(EventData).then(()=>{
    //             success_callback(event.id)
    //         }).catch(()=>{error_callback()})
    //     }
    //     else
    //     {
    //         success_callback(event.id)
    //     }
    // }
    else {
      db.table(event.tableName)
        .put(EventData)
        .then(() => {
          success_callback(event.id)
        })
        .catch(() => {
          error_callback()
        })
    }
  }
}

export function getAuthToken() {
  var serializedState = localStorage.getItem('persist:Token')
  var Obj = ''
  if (serializedState != null) {
    Obj = JSON.parse(JSON.parse(serializedState).AuthToken)
  }
  return Obj
}

function convertToString(list) {
  var str = ''
  for (var i in list) {
    str = str == '' ? list[i] : str + ',' + list[i]
  }
  return str
}
